export const FILTERINGFORM_SUBMIT_ERROR = 'FILTERINGFORM_SUBMIT_ERROR';
export const FILTERINGFORM_SUBMIT_PENDING = 'FILTERINGFORM_SUBMIT_PENDING';
export const FILTERINGFORM_SUBMIT_SUCCESS = 'FILTERINGFORM_SUBMIT_SUCCESS';
export const CLEAN_CURRENT_FILTERCRITERIA_PROJECTS = 'CLEAN_CURRENT_FILTERCRITERIA_PROJECTS'